import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from "react";
export var useGetModalSizing = function useGetModalSizing(hasImage, isMobile, height, width) {
  var getModalWidthValues = useCallback(function () {
    var modalWidthValues;
    if (isMobile) {
      modalWidthValues = {
        width: "100%",
        minWidth: "100%"
      };
    } else if (width) {
      modalWidthValues = {
        width: width,
        minWidth: width
      };
    } else {
      modalWidthValues = hasImage ? {
        width: "50%",
        minWidth: "810px"
      } : {
        width: "30%",
        minWidth: "383px"
      };
    }
    return modalWidthValues;
  }, [hasImage, isMobile, width]);
  var getModalHeightValues = useCallback(function () {
    var modalHeightValues;
    if (isMobile) {
      modalHeightValues = {
        height: "100%",
        maxHeight: "100vh"
      };
    } else if (height) {
      modalHeightValues = {
        height: height,
        maxHeight: height
      };
    } else {
      modalHeightValues = {
        height: "min-content",
        maxHeight: "80%"
      };
    }
    return modalHeightValues;
  }, [isMobile, height]);
  return _objectSpread(_objectSpread({}, getModalWidthValues()), getModalHeightValues());
};